import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AddEditRoleComponent } from 'src/app/components/security/roles/widgets/manageRole/addeditrole.component';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html'
})
export class RoleComponent implements OnInit {
    public pageSize = 10;
    public currentPage = 0;
    public totalSize = 0;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    roleList: RoleModel[] = [];
    sortedRoleList: RoleModel[] = [];
    roleModel: RoleModel = new RoleModel();
    dataSource = new MatTableDataSource<RoleModel>();
    isAdvanceSearchFilter: boolean = false;
    filterKey: string = '';
    currentSort!: Sort;
    selectedProductCode!: string;

    displayedColumns = ['name', 'description', 'action'];
    isWritePermission: boolean = true;
    constructor(public _restAPI: RestAPIService,
        public dialog: MatDialog, private permissionService: PermissionService) {
            this._restAPI.loading  = false;
            if(!this.permissionService.has('roles.write')){
                this.isWritePermission = false;
                this.displayedColumns = this.displayedColumns.filter(col => col !== 'action');
            }
        }
  
    ngOnInit() {
        if (localStorage["applyRoleFilterValue"] === 'true') {
            this.getRoleList(localStorage["roleFilterValue"]);
        }
        else {
            this.getRoleList('');
        }
        localStorage["applyRoleFilterValue"] = '';
    }

    onDisplayFilter(e : any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }
    applyFilter(filterValue: string) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        localStorage["roleFilterValue"] = filterValue;
        this.dataSource.filter = filterValue;
    }

    //#region Open dialog

    openRoleDialog(roleModel: RoleModel): void {
        const dialogRef = this.dialog.open(AddEditRoleComponent, {
            width:"700px",
            data: roleModel
        });

        dialogRef.afterClosed().subscribe(result => {
            this.roleModel = new RoleModel();
            if (result) {
                this.getRoleList(localStorage["roleFilterValue"]);
            }
            localStorage["applyRoleFilterValue"] = '';
        });
    }
  
    //#endregion
    
    async getRoleList(filterValue : any) {
        this._restAPI.loading  = true;
        this._restAPI.get<RoleModel[]>(environment.apiURL + 'api/role/list').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.roleList = data;
                this.sortedRoleList = this.roleList.slice();
                this.totalSize = this.sortedRoleList.length;
                this.dataSource.data = data;
                this.dataSource.filter = filterValue;
                this.filterKey = filterValue;
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    sortRoles(sort: Sort) {
        if (this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = 0;
        }
        this.dataSource.filter = "";
        this.filterKey = "";
        this.currentSort = sort;
        this.pageSize = 10;
        this.currentPage = 0;
        this.sortRoleArray(this.roleList.slice(), this.currentSort);
        this.dataSource.data = this.sortedRoleList;
    }

    private sortRoleArray(roles: RoleModel[], sort: Sort): void {
        if (sort === undefined || !sort.active || sort.direction === '') {
            this.sortedRoleList = roles.slice();
            return;
        }

        this.sortedRoleList = roles.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'code': return compare(a.code ?? '', b.code ?? '', isAsc);
                case 'name': return compare(a.name ?? '', b.name ?? '', isAsc);
                case 'description': return compare(a.description ?? '', b.description ?? '', isAsc);
                default: return 0;
            }
        });

        const part = this.sortedRoleList.slice();
        this.sortedRoleList = [];
        for (const item of part) {
            this.sortedRoleList.push(item);
        }
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}